export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6155.56229168.jpg";